import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from 'src/app/shared/auth/auth.service';
import { BaseComponent } from 'src/app/shared/base/base.component';
import { URLConst } from 'src/app/shared/const/url.const';
import { EnvironmentconfigService } from '../../../shared/service/environmentconfig.service'
import { WebApiService } from 'src/app/shared/service/webapi.service';
import { NzMessageService } from "ng-zorro-antd/message";
import { NzUploadChangeParam, NzUploadFile } from 'ng-zorro-antd/upload';
import { differenceInCalendarDays, setHours } from 'date-fns';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-edit-wmsm001',
  templateUrl: './edit-wmsm001.component.html',
  styleUrls: ['./edit-wmsm001.component.scss', '../../WMSM.component.css']
})
export class EditWMSM001Component extends BaseComponent implements OnInit {
  @Input() isEdit: boolean = false;
  @Input() editData: any;
  @Output() close = new EventEmitter<any>();
  @Output() save = new EventEmitter<any>();
  validateForm: FormGroup;
  Role :any
  dateFormat = 'yyyy/MM/dd';
  ReasonList: any;
  loading: boolean = false;
  CreatReason: any;
  tw: boolean = true;
  fileList: NzUploadFile[] = [];
  ActualArrivalfileList: NzUploadFile[] = [];
  cn: boolean;
  en: boolean;
  vn:boolean;
  Required:boolean=true
  VendorRequired:boolean=true
  ShipmentfFile: NzUploadFile = null;
  ActualArrivalfFile: NzUploadFile = null;
  public shouldDisplayNotFound: boolean = false;
  public isFileUploaded = false;
  ShippingFileName:string = null
  vDeliverGoodsFileName:string = null
  vDispatchFile:string = null
  vDeliverGoodsFile:string = null
  today = new Date();
  DeleteVDeliverGoodsFile:boolean = false
  DeleteShippingFile:boolean = false
  Approvedate: Date;
  constructor(
    private fb: FormBuilder,
    private AuthService: AuthService,
    private EnvironmentconfigService: EnvironmentconfigService,
    private WebApiService: WebApiService,
    private NzMessageService: NzMessageService,
    private translate: TranslateService,
  ) { super();

  }

  async ngOnInit(): Promise<void> {
    this.Approvedate = new Date(this.editData.approvedate);
    if (sessionStorage.getItem("wmsmlang") == "zh-CN") {
      this.cn = true;
      this.tw = false;
      this.en = false;
      this.vn = false
    }
    if (sessionStorage.getItem("wmsmlang") == "zh-TW") {
      this.tw = true;
      this.cn = false;
      this.en = false;
      this.vn = false
    }
    if (sessionStorage.getItem("wmsmlang") == "en") {
      this.en = true;
      this.cn = false;
      this.tw = false;
      this.vn = false
    }
    if (sessionStorage.getItem("wmsmlang") == "VN") {
      this.en = false;
      this.cn = false;
      this.tw = false;
      this.vn = true
    }

    this.validateForm = this.fb.group({
      VendorDate: [''],
      UserDate: [''],
      remark: [''],
      Company: [''],
      PONO: [''],
      POLN: [''],
      Reason: [''],
      ActualArrivalDate: [''],
      ShipmentDate: [''],
    });
    this.GetUreasonList();
    const url = `${this.EnvironmentconfigService.authConfig.wmsmUrl}${URLConst.GetWHQRole.url}`;
    const params = {};
    try {
      const res = await this.WebApiService.doGet(url, params).toPromise();

      this.Role = res.data[0];
    } catch (error) {
      console.error(error);
    }
    if (this.Role) {

      if (this.Role.includes("0")) { }
      if (this.Role.includes("1")) { this.validateForm.controls['VendorDate'].disable();this.VendorRequired = false; this.validateForm.controls['remark'].disable(); this.validateForm.controls['Reason'].disable(); }
      if (this.Role.includes("2")) { this.validateForm.controls['UserDate'].disable(); this.Required = false;  }
      ;
    }
    if (this.editData) {
      this.validateForm.controls['VendorDate'].setValue(this.editData['vDate']);
      this.validateForm.controls['UserDate'].setValue(this.editData['uDate']);
      this.validateForm.controls['remark'].setValue(this.editData['vendorRemark']);
      this.validateForm.controls['Company'].setValue(this.editData['companyCode']);
      this.validateForm.controls['PONO'].setValue(this.editData['pono']);
      this.validateForm.controls['POLN'].setValue(this.editData['poln']);
      this.validateForm.controls['ShipmentDate'].setValue(this.editData['vDeliveryDate']);
      this.validateForm.controls['ActualArrivalDate'].setValue(this.editData['vAcDate']);
      this.ShippingFileName = this.editData.vDispatchFileName
      this.vDeliverGoodsFileName = this.editData.vDeliverGoodsFileName
      this.vDispatchFile = this.editData.vDispatchFile
      this.vDeliverGoodsFile = this.editData.vDeliverGoodsFile
    }

    this.validateForm.controls['Company'].disable();
    this.validateForm.controls['PONO'].disable();
    this.validateForm.controls['POLN'].disable();

  }
  // 關閉彈窗
  onClose(): void {
    this.close.emit();
    this.ShipmentfFile = null;
    this.ActualArrivalfFile = null;
    if (!this.isEdit) {
      this.resetForm();
    }
  }

  async GetRole() {
    const url = `${this.EnvironmentconfigService.authConfig.wmsmUrl}${URLConst.GetWHQRole.url}`;
    const params = {};
    try {
      const res = await this.WebApiService.doGet(url, params).toPromise();
      debugger;
      this.Role = res.data[0];
    } catch (error) {
      console.error(error);
    }
  }

  // 重置表单
  resetForm(): void {
    this.validateForm.reset();
    for (const key in this.validateForm.controls) {
      this.validateForm.controls[key].markAsPristine();
      this.validateForm.controls[key].updateValueAndValidity();
    }
  }

  submitForm = ($event: any, value: any) => {

    // if (this.validateForm.controls["VendorDate"].value == null || this.validateForm.controls["VendorDate"].value == undefined)
    //   {
    //     if (this.tw) {
    //       return this.NzMessageService.warning('必填選項不能爲空!');
    //     }
    //     if (this.cn) {
    //       return this.NzMessageService.warning('必填选项不能为空!');
    //     }
    //     if (this.en) {
    //       return this.NzMessageService.warning('Mandatory fields cannot be empty!');
    //     }
    // }
    //
    // if ( DateUtil.formatYMD(this.validateForm.controls["VendorDate"].value) > DateUtil.formatYMD(this.validateForm.controls["UserDate"].value)) {
    //   if (this.validateForm.controls["Reason"].value == ""|| this.validateForm.controls["Reason"].value == null || this.validateForm.controls["remark"].value == "" || this.validateForm.controls["remark"].value == null) {
    //     if (this.tw) {
    //       return this.NzMessageService.warning('供应商日期大于用户需求日期时，交期不滿足需求或延遲因素与备注不能为空!');
    //     }
    //     if (this.cn) {
    //       return this.NzMessageService.warning('供应商日期大于用户需求日期时，交期不满足需求或延迟因素与备注不能为空!');
    //     }
    //     if (this.en) {
    //       return this.NzMessageService.warning('If the supplier date is greater than the users required date, the delivery time does not meet the demand or the delay factor and remarks cannot be left blank!');
    //     }
    //     return
    //   }
    // }

    // if (this.validateForm.controls["ActualArrivalDate"].value != null || this.validateForm.controls["ActualArrivalDate"].value != undefined) {
    //   if (this.ActualArrivalfFile == null || this.ActualArrivalfFile == undefined) {
    //     if (this.tw) {
    //       return this.NzMessageService.warning('請上傳送貨單文件!');
    //     }
    //     if (this.cn) {
    //       return this.NzMessageService.warning('请上传送货文件!');
    //     }
    //     if (this.en) {
    //       return this.NzMessageService.warning('Please upload the delivery file!');
    //     }

    //   }
    // }

    // if (this.ActualArrivalfFile != null || this.ActualArrivalfFile != undefined) {
    //   if (this.validateForm.controls["ActualArrivalDate"].value == null || this.validateForm.controls["ActualArrivalDate"].value == undefined) {
    //     if (this.tw) {
    //       return this.NzMessageService.warning('請選擇實際到場日期!');
    //     }
    //     if (this.cn) {
    //       return this.NzMessageService.warning('请选择实际到场日期!');
    //     }
    //     if (this.en) {
    //       return this.NzMessageService.warning('Please select the actual date of attendance!');
    //     }

    //   }
    // }


    $event.preventDefault();
    for (const key in this.validateForm.controls) {
      this.validateForm.controls[key].markAsDirty();
      this.validateForm.controls[key].updateValueAndValidity();
    }
    let obj = {};
    const actualArrivalDate = this.validateForm.controls["ActualArrivalDate"].value;
    const shipmentDate = this.validateForm.controls["ShipmentDate"].value;
    if (actualArrivalDate && shipmentDate) {
      const differenceInDays = (new Date(actualArrivalDate).getTime() - new Date(shipmentDate).getTime()) / (1000 * 60 * 60 * 24);
      if (differenceInDays > 7) {
        return this.translate.get('actualArrivalDateExceedsShipmentDate').subscribe((translatedText : string) => {
       this.NzMessageService.warning(translatedText);
        })
      }
    }
    obj["vDate"] = this.getTheDateString_(this.validateForm.controls["VendorDate"].value) || '';
    obj["uDate"] = this.getTheDateString_(this.validateForm.controls["UserDate"].value) || '';
    obj["vendorRemark"] = this.validateForm.controls["remark"].value || '';
    obj["unreasonCode"] = this.validateForm.controls["Reason"].value == null ? '' : this.validateForm.controls["Reason"].value.unreasonCode;
    obj["unreason"] = this.validateForm.controls["Reason"].value == null ? '' : this.validateForm.controls["Reason"].value.unreason;
    obj["VDeliveryDate"] = this.getTheDateString_(this.validateForm.controls["ShipmentDate"].value) || '';
    obj["VAcDate"] = this.getTheDateString_(this.validateForm.controls["ActualArrivalDate"].value) || '';
    obj["VDispatchFile"] = this.ShipmentfFile;
    obj["VDeliverGoodsFile"] = this.ActualArrivalfFile;
    obj["DeleteVDeliverGoodsFile"] = this.DeleteVDeliverGoodsFile;
    obj["DeleteShippingFile"] = this.DeleteShippingFile;
    obj["vDeliverGoodsFiletoken"] = this.vDeliverGoodsFile;
    obj["vDispatchFiletoken"] = this.vDispatchFile;
    obj["ShippingFileName"] = this.ShippingFileName;
    obj["vDeliverGoodsFileName"] = this.vDeliverGoodsFileName;

    if (this.editData) {
      obj = Object.assign(this.editData, obj);
    }
    this.save.emit(obj);
  };

  GetUreasonList(): void {
    this.loading = true;
    const params = '';
    const url = `${this.EnvironmentconfigService.authConfig.wmsmUrl}${URLConst.GetUreasonList.url}`;
    this.WebApiService.doGet(url, params).subscribe(
      (res) => {
        if (res && res.status == this.EnvironmentconfigService.authConfig.wmsmStatus) {
          this.ReasonList = res.data;
          this.CreatReason = res.data.map(item => {
            if (item.unreasonCode == this.editData.unreasonCode) {
              this.validateForm.controls['Reason'].setValue(item)
              return item;
            }
          });
        } else {
          this.NzMessageService.error(res.msg);
        }
        this.loading = false;
      },
      (error) => {
        this.NzMessageService.error(error.msg);
        this.loading = false;
      }

    );
  }



  public ShipmentHandleChange(info: NzUploadChangeParam): void {
    if (info.file.status === 'removed') {
      this.translate.get('FileRemoved').subscribe((translatedText : string) => {
        this.NzMessageService.success(translatedText);
      })

    }
  }


  ShipmentBeforeUploadFile = (file: NzUploadFile) => {
    this.fileList = [file];
    this.ShipmentfFile = file;

    if (file.size > 1024 * 1024 * 10) {
      this.translate.get('FileSizeIsTooLarge').subscribe((translatedText : string) => {
        this.NzMessageService.warning(translatedText);
      })
      //this.NzMessageService.warning('上传文件不能超过10MB!');
      return false;
    }
    this.translate.get('UploadSuccess').subscribe((translatedText : string) => {
      this.NzMessageService.success(translatedText);
    })
  };

  public ActualArrivalhandleChange(info: NzUploadChangeParam): void {

    if (info.file.status === 'removed') {
      this.translate.get('FileRemoved').subscribe((translatedText : string) => {
        this.NzMessageService.success(translatedText);
      })

    }

  }


  ActualArrivalbeforeUploadFile = (file: NzUploadFile) => {
    this.ActualArrivalfileList =[file]
    this.ActualArrivalfFile = file;

    if (file.size > 1024 * 1024 * 10) {
      this.translate.get('FileSizeIsTooLarge').subscribe((translatedText : string) => {
        this.NzMessageService.warning(translatedText);
      })
      return false;
    }
    this.translate.get('UploadSuccess').subscribe((translatedText : string) => {
      this.NzMessageService.success(translatedText);
    })
  };

  onDeleteShippingFile(){
    this.ShippingFileName =null
    this.validateForm.controls['ShipmentDate'].setValue('');
    this.DeleteShippingFile = true;
    // const params = {

    // }
    // const url = `${this.EnvironmentconfigService.authConfig.wmsmUrl}${URLConst.DeletePOFile.url}?Filetoken=` +  this.vDispatchFile + '&type=' +"A" ;
    // this.WebApiService.doPost(url, params).subscribe(
    //   (res) => {
    //     this.NzMessageService.success("成功删除");
    //     this.WMSM001Component.getResultData()
    //   },
    //   (error) => {
    //     this.NzMessageService.error(error.msg);
    //   }
    // );

  }

  onDeleteVDeliverGoodsFile(){
    this.vDeliverGoodsFileName =null
    this.DeleteVDeliverGoodsFile = true;
    // const params = {

    // }
    // const url = `${this.EnvironmentconfigService.authConfig.wmsmUrl}${URLConst.DeletePOFile.url}?Filetoken=` +  this.vDeliverGoodsFile + '&type=' +"B" ;
    // this.WebApiService.doPost(url, params).subscribe(
    //   (res) => {
    //     this.NzMessageService.success("成功删除");
    //     this.WMSM001Component.getResultData()
    //   },
    //   (error) => {
    //     this.NzMessageService.error(error.msg);
    //   }
    // );
  }

  disabledDate = (current: Date): boolean =>
    // Can not select days after today and before Approvedate
    differenceInCalendarDays(current, this.today) > 0 || differenceInCalendarDays(current, this.Approvedate) < 0;

  DisabledBeforeDate= (current: Date): boolean =>
    // Can not select days before today and today
    differenceInCalendarDays(current, this.today) < 0;

    DisabledVendorDate= (current: Date): boolean =>
      // Can not select days before today and today
    differenceInCalendarDays(current, this.Approvedate) < 0;
}
